<template>
  <lida-table
    :propscolumns="columns"
    :data="rateData"
    :sortStatus="false"
    align="right"
    :SpinLoading="loading"
    :propsPageSize="50"
    class="my-2"
    :LeaveSpace="false"
  >
    <template v-slot:headerSelect>
      <p class="title text-left">站点本占比总计</p>
    </template>
  </lida-table>
</template>
<script>
import { mapGetters, mapActions } from 'vuex'
import reportCount from '@/mixins/report-count.js'
export default {
  mixins: [reportCount],
  props: {
    rateData: {
      type: Array,
      default: () => []
    }
  },
  data () {
    return {
      loading: false
    }
  },
  computed: {
    ...mapGetters(['getAllGame']),
    columns () {
      const object = {
        indexNumber: {
          title: '序号',
          align: 'center',
          key: 'indexNumber',
          width: 50
        },
        stname: {
          title: '站点',
          align: 'center',
          key: 'stname',
          totaltext: '总计',
          width: 200
        },
        mytlpa: {
          title: '本占比',
          align: 'center',
          key: 'mytlpa',
          render: (h, params) => {
            if (params.row.stname == '总计') return ''
            return h('p', `${params.row.mytlpa}%`)
          }
        },
        value: {
          title: '下注金额',
          align: 'center',
          key: 'value',
          total: true,
          width: 100,
          render: (h, params) => this.renderColorAmount(h, params, 'value')
        },
        effval: {
          title: '有效额',
          align: 'center',
          key: 'effval',
          className: 'trigger-show',
          triggerShow: true,
          total: true,
          render: (h, params) => {
            const value = params.row.effval * -1
            return h('span', this.NegativeColor(value), this.toDecimal2(value))
          }
        },
        bonus: {
          title: '会员奖金',
          align: 'center',
          key: 'bonus',
          className: 'trigger-show',
          triggerShow: true,
          total: true,
          render: (h, params) => {
            const value = params.row.mpaysum - params.row.payds
            return h('span', this.NegativeColor(value), this.toDecimal2(value))
          }
        },
        payds: {
          title: '会员佣金',
          align: 'center',
          key: 'payds',
          className: 'trigger-show',
          triggerShow: true,
          total: true,
          render: (h, params) => this.renderColorAmount(h, params, 'payds')
        },
        mpaysum: {
          title: '会员盈亏',
          align: 'center',
          key: 'mpaysum',
          total: true,
          render: (h, params) => this.renderColorAmount(h, params, 'mpaysum')
        },
        l2upps: {
          title: '分公司占成上缴',
          align: 'center',
          key: 'l2upps',
          total: true,
          width: 120,
          render: (h, params) => this.renderColorAmount(h, params, 'l2upps')
        },
        l2upt: {
          title: '分公司上缴',
          align: 'center',
          key: 'l2upt',
          total: true,
          render: (h, params) => this.renderColorAmount(h, params, 'l2upt')
        },
        l1pays: {
          title: '公司占成',
          align: 'center',
          key: 'l1pays',
          total: true,
          render: (h, params) => this.renderColorAmount(h, params, 'l1pays')
        },
        l1paysumt: {
          title: '公司占成盈亏',
          align: 'center',
          key: 'l1paysumt',
          className: 'trigger-show',
          triggerShow: true,
          total: true,
          render: (h, params) => this.renderColorAmount(h, params, 'l1paysumt')
        },
        mid: {
          title: '公司补货奖金',
          align: 'center',
          key: 'mid',
          total: true,
          render: (h, params) => {
            return h('span', 0)
          },
        },
        bupayds: {
          title: '公司补货佣金',
          align: 'center',
          key: 'bupayds',
          total: true,
        },
        l1pds: {
          title: '公司赚佣',
          align: 'center',
          key: 'l1pds',
          className: 'trigger-show',
          triggerShow: true,
          total: true,
          render: (h, params) => this.renderColorAmount(h, params, 'l1pds')
        },
        l1paysum: {
          title: '公司盈亏',
          align: 'center',
          key: 'l1paysum',
          total: true,
          render: (h, params) => this.renderColorAmount(h, params, 'l1paysum')
        }
      }

      return object
    }
  },
  methods: {}
}
</script>